import { render } from "./CloseButton.vue?vue&type=template&id=17ec629c&scoped=true"
import script from "./CloseButton.vue?vue&type=script&lang=js"
export * from "./CloseButton.vue?vue&type=script&lang=js"

import "./CloseButton.vue?vue&type=style&index=0&id=17ec629c&scoped=true&lang=css"

import exportComponent from "/home/runner/work/mamidou/mamidou/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17ec629c"]])

export default __exports__